import React, { useEffect, useRef, useState } from "react";
import "./AssetSize.scss";
import { useDispatch, useSelector } from "react-redux";
import {
  setAssetSize,
  setClearAll,
} from "../../../../rtk-query/features/cohort/cohortSlice";
import { useDebounce } from "primereact/hooks";
import { Skeleton } from "primereact/skeleton";

export const IN_MILLION = 1_000_000;
export const ASSET_SIZE_MIN_PLACEHOLDER = 0;
export const ASSET_SIZE_MAX_PLACEHOLDER = 5_000_000_000_000 / IN_MILLION;

const formatTwoDecimals = (val) => {
  if (val === null || val === undefined || val === "") return "";
  return Number(val).toFixed(2);
};

const AssetSize = ({ minError, setMinError, maxError, setMaxError }) => {
  const dispatch = useDispatch();

  const assetSize = useSelector((state) => state?.cohortReducer?.assetSize);

  const selectedCohort = useSelector(
    (state) => state?.cohortReducer?.selectedCohort,
  );
  const clearAll = useSelector((state) => state?.cohortReducer?.clearAll);
  const isFieldsEditiable = useSelector(
    (state) => state?.cohortReducer?.isFieldsEditiable,
  );

  const validate = (minValue, maxValue) => {
    if (minValue && Number(minValue) < ASSET_SIZE_MIN_PLACEHOLDER) {
      setMinError(`Min should be ≥ ${ASSET_SIZE_MIN_PLACEHOLDER}`);
    } else if (
      Number(minValue) >= Number(maxValue || ASSET_SIZE_MAX_PLACEHOLDER)
    ) {
      setMinError("Min cannot be greater than equal to Max");
    } else {
      setMinError("");
    }
    if (maxValue && Number(maxValue) > ASSET_SIZE_MAX_PLACEHOLDER) {
      setMaxError(`Max should be ≤ ${ASSET_SIZE_MAX_PLACEHOLDER}`);
    } else if (
      Number(maxValue || ASSET_SIZE_MAX_PLACEHOLDER) <= Number(minValue)
    ) {
      setMaxError("Max cannot be less than equal to Min");
    } else {
      setMaxError("");
    }

    if (minValue === "" && maxValue === "") {
      setMinError("");
      setMaxError("");
    }
  };

  const [minValue, debouncedMinValue, setMinValue] = useDebounce("", 400);
  const [maxValue, debouncedMaxValue, setMaxValue] = useDebounce("", 400);
  useEffect(() => {
    dispatch(
      setAssetSize({
        ...assetSize,
        minValue: debouncedMinValue,
        maxValue: debouncedMaxValue,
      }),
    );
    validate(debouncedMinValue, debouncedMaxValue);
  }, [debouncedMinValue, debouncedMaxValue]);

  useEffect(() => {
    setMinValue(
      formatTwoDecimals(
        selectedCohort?.filterJson?.assets?.min != null
          ? selectedCohort?.filterJson?.assets?.min / IN_MILLION
          : assetSize?.minValue
            ? assetSize?.minValue
            : "",
      ),
    );
    setMaxValue(
      formatTwoDecimals(
        selectedCohort?.filterJson?.assets?.max != null
          ? selectedCohort?.filterJson?.assets?.max / IN_MILLION
          : assetSize?.maxValue
            ? assetSize?.maxValue
            : "",
      ),
    );
  }, [selectedCohort?.filterJson?.assets]);

  useEffect(() => {
    if (clearAll) {
      setMinValue("");
      setMaxValue("");
      setTimeout(() => {
        dispatch(setClearAll(false));
      }, 1000);
    }
  }, [clearAll]);

  return (
    <div className="asset-size">
      {!clearAll ? (
        <div className="input-container">
          <div className="input-field">
            <div className="field">
              <span className="dollar-icon">$</span>
              <input
                placeholder={`${ASSET_SIZE_MIN_PLACEHOLDER}.00`}
                value={minValue ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(value)) {
                    setMinValue(value);
                  }
                }}
                disabled={!isFieldsEditiable}
                // disabled={selectedCohort != null}
              />
            </div>
            <div className="error-container">
              {minError && <span className="error-text">{minError}</span>}
            </div>
          </div>
          <div className="input-field">
            <div className="field">-</div>
          </div>
          <div className="input-field">
            <div className="field">
              <span className="dollar-icon">$</span>
              <input
                placeholder={`${ASSET_SIZE_MAX_PLACEHOLDER}.00`}
                value={maxValue ?? ""}
                onChange={(e) => {
                  const value = e.target.value;
                  if (/^\d*\.?\d{0,2}$/.test(value)) {
                    setMaxValue(value);
                  }
                }}
                disabled={!isFieldsEditiable}
                // disabled={selectedCohort != null}
              />
            </div>
            <div className="error-container">
              {maxError && <span className="error-text">{maxError}</span>}
            </div>
          </div>
        </div>
      ) : (
        <div className="input-container d-flex">
          <div className="input-field" style={{ flex: 1 }}>
            <Skeleton height="3rem" />
            <div className="error-container">
              {minError && <span className="error-text">{minError}</span>}
            </div>
          </div>
          <div
            className="input-field"
            style={{ alignSelf: "normal", marginTop: "1rem" }}
          >
            -
          </div>
          <div className="input-field" style={{ flex: 1 }}>
            <Skeleton height="3rem" />
            <div className="error-container">
              {minError && <span className="error-text">{minError}</span>}
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AssetSize;
